module.exports = __webpack_public_path__ + "img/notifi-info.81d20112.svg";